import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import TenantFeaturesPanel from './TenantFeaturesPanel';
import VersionFeaturesPanel from './VersionFeaturesPanel';

const ManageFeaturesModal = ({
  isOpen,
  onClose,
  initialTab = 'tenant',
  preselectedTenantId = null,
  tenants,
  labelOptions,
  tenantFeatureOptions,
  versionDefinitions,
  versionLoading,
  versionError,
  versionUpdating,
  versionDeleting,
  onApplyTenantFeatures,
  onSaveVersionDefinition,
  onDeleteVersionDefinition,
  tenantFeaturesSaving,
  tenantFeaturesError,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [selectedTenantIds, setSelectedTenantIds] = useState(() => new Set());

  useEffect(() => {
    if (!isOpen) {
      setActiveTab('tenant');
      setSelectedTenantIds(new Set());
      return;
    }
    setActiveTab(initialTab);
    if (preselectedTenantId) {
      setSelectedTenantIds(new Set([preselectedTenantId]));
    } else {
      setSelectedTenantIds(new Set());
    }
  }, [isOpen, initialTab, preselectedTenantId]);

  if (!isOpen) return null;

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div
        className="stm-modal stm-modal--xl stm-modal--features"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="stm-modal__header stm-modal__header--features">
          <div className="stm-manage-features-header">
            <div className="stm-manage-features-header__top">
              <div>
                <h2>Manage Features</h2>
                <p className="stm-modal__subtitle stm-modal__subtitle--compact">
                  Manage tenant-specific and version-level feature configuration.
                </p>
              </div>
              <button
                type="button"
                className="stm-icon-btn stm-icon-btn--sm"
                onClick={onClose}
                disabled={tenantFeaturesSaving || versionUpdating || versionDeleting}
                aria-label="Close"
              >
                <FaTimes />
              </button>
            </div>
            <div className="stm-manage-features-tabs" role="tablist" aria-label="Feature management sections">
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === 'tenant'}
                className={activeTab === 'tenant' ? 'is-active' : ''}
                onClick={() => setActiveTab('tenant')}
              >
                Tenant Features
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === 'version'}
                className={activeTab === 'version' ? 'is-active' : ''}
                onClick={() => setActiveTab('version')}
              >
                Version Features
              </button>
            </div>
          </div>
        </header>

        <div className="stm-modal__body stm-modal__body--tabs stm-modal__body--features">
          <div key={activeTab} className="stm-manage-features-panel">
            {activeTab === 'tenant' ? (
              <TenantFeaturesPanel
                tenants={tenants}
                labelOptions={labelOptions}
                featureSuggestions={tenantFeatureOptions}
                selectedTenantIds={selectedTenantIds}
                onSelectedTenantIdsChange={setSelectedTenantIds}
                onApply={onApplyTenantFeatures}
                isSaving={tenantFeaturesSaving}
                error={tenantFeaturesError}
              />
            ) : (
              <VersionFeaturesPanel
                definitions={versionDefinitions}
                loading={versionLoading}
                error={versionError}
                updating={versionUpdating}
                deleting={versionDeleting}
                labelSuggestions={labelOptions}
                onSaveDefinition={onSaveVersionDefinition}
                onDeleteDefinition={onDeleteVersionDefinition}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageFeaturesModal;
